<template>
<svg width="90" height="90" viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
        <filter x="-70%" y="-50%" width="240%" height="240%" filterUnits="objectBoundingBox" id="d7lbuz5gda">
            <feMorphology radius="5" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dy="10" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="15" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0.239215686 0 0 0 0 0.239215686 0 0 0 0 0.239215686 0 0 0 0.222929414 0" in="shadowBlurOuter1"/>
        </filter>
        <rect id="hw25slt5vb" x="0" y="0" width="50" height="50" rx="25"/>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <g transform="translate(20 10)">
            <use fill="#000" filter="url(#d7lbuz5gda)" xlink:href="#hw25slt5vb"/>
            <use fill="#FFF" xlink:href="#hw25slt5vb"/>
        </g>
        <path d="M40.456 29.495v15.5h-5.151v-15.5h5.151zm12.646-.363c3.389 0 5.93 2.215 5.93 6.976v8.887h-5.15v-8.292c0-2.084-.746-3.505-2.61-3.505-1.424 0-2.271.959-2.644 1.884-.136.331-.17.794-.17 1.257v8.656h-5.151v-15.5h5.152v2.195c.684-1.056 1.91-2.558 4.643-2.558zm-15.188-7.109c1.763 0 2.848 1.158 2.881 2.679 0 1.487-1.118 2.677-2.915 2.677h-.033c-1.73 0-2.847-1.19-2.847-2.677 0-1.521 1.152-2.679 2.914-2.679z" fill="#FFB402"/>
    </g>
</svg>
</template>

<script>
export default {

}
</script>

<style>
svg path {
    fill: var(--color-primary);
}
</style>